import { fetchEventSource } from "@microsoft/fetch-event-source";
import axiosInstance from "../axiosInstance";

const getApiBaseUrl = () => {
    const baseURL = axiosInstance.defaults.baseURL || "";

    return baseURL.replace(/\/+$/, "");
};

const getAccessToken = () => {
    return localStorage.getItem("token");
};

export const subscribeTaxiRoutingJob = async ({
    jobId,
    signal,
    onProgress,
    onError,
    onClose
}) => {
    const baseURL = getApiBaseUrl();
    const token = getAccessToken();

    if (!jobId) {
        throw new Error("jobId es obligatorio.");
    }

    await fetchEventSource(
        `${baseURL}/administration/taxi-service/routing-jobs/${jobId}/events`,
        {
            method: "GET",
            signal,

            headers: {
                Accept: "text/event-stream",
                ...(token
                    ? {
                        Authorization: `Bearer ${token}`
                    }
                    : {})
            },

            openWhenHidden: true,

            async onopen(response) {
                if (response.ok) {
                    return;
                }

                let errorMessage =
                    `No se pudo conectar al progreso VRP. HTTP ${response.status}`;

                try {
                    const body = await response.json();

                    errorMessage =
                        body?.message ||
                        body?.error ||
                        errorMessage;
                } catch {
                    // La respuesta podría no ser JSON.
                }

                throw new Error(errorMessage);
            },

            onmessage(event) {
                if (
                    event.event !== "progress" ||
                    !event.data
                ) {
                    return;
                }

                try {
                    const progressData = JSON.parse(
                        event.data
                    );

                    onProgress?.(progressData);
                } catch (error) {
                    console.error(
                        "Evento SSE VRP inválido:",
                        error
                    );
                }
            },

            onclose() {
                onClose?.();
            },

            onerror(error) {
                onError?.(error);

                /*
                 * Lanzar el error impide que fetch-event-source
                 * se reconecte infinitamente.
                 *
                 * La recuperación se hará consultando el endpoint
                 * GET del job.
                 */
                throw error;
            }
        }
    );
};